import ViewCategory from "./ViewCategory";

const FrontRow = ({ comment, weekNumbers }) => {
	return (
		<tr key={comment.id}>
			<td>
				<span className={"form-control first-column border-0"}>
					{comment.comment}
				</span>
			</td>
			{weekNumbers.map((weekNumber, weekIndex) => (
				<ViewCategory
					key={weekIndex}
					comment={comment}
					weekNumber={weekNumber}
				/>
			))}
		</tr>
	);
};

export default FrontRow;
